import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var TagsService = /** @class */ (function () {
    function TagsService(http) {
        this.http = http;
    }
    // get /api/v1/employer/tag
    TagsService.prototype.getTags = function () {
        return this.http.get(environment.baseUrlWs + environment.wsVerison + 'employer/tag');
    };
    // post /api/v1/employer/tag
    TagsService.prototype.saveTags = function (entity_id, tags, type) {
        return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/tag', {
            type: type,
            entity_id: entity_id,
            tags: tags
        });
    };
    // delete /api/v1/employer/tag
    TagsService.prototype.deleteTags = function (entity_id, tags) {
        var options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            body: {
                type: 'application',
                entity_id: entity_id,
                tags: tags
            },
        };
        return this.http.delete(environment.baseUrlWs + environment.wsVerison + 'employer/tag', options);
    };
    /////////////
    TagsService.prototype.getCurriculaTagsByApplicationId = function (applications_id) {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/curricula/" + applications_id + "/tags";
        return this.http.get(url);
    };
    TagsService.prototype.putCurriculaTagByApplicationId = function (applications_id, tag) {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/curricula/" + applications_id + "/tags";
        return this.http.put(url, tag);
    };
    TagsService.prototype.deleteCurriculaTagByApplicationId = function (applications_id, id) {
        var url = "" + environment.baseUrlWs + environment.wsVerison + "employer/curricula/" + applications_id + "/tags/" + id;
        return this.http.delete(url);
    };
    TagsService.ngInjectableDef = i0.defineInjectable({ factory: function TagsService_Factory() { return new TagsService(i0.inject(i1.HttpClient)); }, token: TagsService, providedIn: "root" });
    return TagsService;
}());
export { TagsService };
